export default __webpack_public_path__ + "static/media/chevrolet.1401ddf0.png";